export default __webpack_public_path__ + "static/media/G0430.34I-27378_-16465_0.1666263600000.63c39c5d.jpg";